"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TemperatureBox = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.number.to-fixed.js");
var _react = _interopRequireWildcard(require("react"));
var _paulCorePackage = require("paul-core-package");
var _reactRedux = require("react-redux");
var _TemperatureBoxModule = _interopRequireDefault(require("../../styles/components/TemperatureBox.module.css"));
var _hooks = require("../../hooks");
var _useGetValue = require("../../hooks/useGetValue");
var _constants = require("../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const {
  LoopType,
  SectionTypes
} = _paulCorePackage.constants;
const TemperatureBox = _ref => {
  var _useSelector, _useSelector$Default;
  let {
    thingPDIDDevice = null,
    moreThanTwo = false,
    alone = false
  } = _ref;
  const {
    thingLoopType = '',
    thingSectionType = ''
  } = (0, _hooks.useGetDeviceByPdid)({
    thingPDIDDevice
  });
  const tV = (0, _paulCorePackage.useTranslationValue)();
  const temperatureIds = (0, _useGetValue.useGetValueIdsByRegDeviceId)({
    thingPDIDDevice,
    regular: _paulCorePackage.constants.regularsByDisplayNameId.temperatureRegex
  });
  /** will not work with energyValve */
  const [temperature, unit] = (0, _useGetValue.useGetValueParamsByDisplayNameId)({
    displayNameId: temperatureIds[0],
    thingPDIDDevice,
    params: [_constants.valueParamsName.value, _constants.valueParamsName.unit]
  });
  const tVUnit = (_useSelector = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsValues)) === null || _useSelector === void 0 ? void 0 : (_useSelector$Default = _useSelector.Default) === null || _useSelector$Default === void 0 ? void 0 : _useSelector$Default.unit;
  const tUnit = tVUnit ? tVUnit[unit] : '';
  const isCorrectTemperature = temperature && temperature > 0 && temperature < 100;
  const isCorrectLoopType = Number(thingLoopType === null || thingLoopType === void 0 ? void 0 : thingLoopType.id) !== LoopType.none;
  const isCorrectSectionType = Number(thingSectionType === null || thingSectionType === void 0 ? void 0 : thingSectionType.id) !== SectionTypes.none;
  const text = "".concat(isCorrectLoopType ? "".concat(tV(thingLoopType === null || thingLoopType === void 0 ? void 0 : thingLoopType.value), " ") : '').concat(isCorrectSectionType ? "".concat(tV(thingSectionType === null || thingSectionType === void 0 ? void 0 : thingSectionType.value), " ") : '');
  const {
    71: tTemperature
  } = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsInterfaceUILocalizations);
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_TemperatureBoxModule.default.temperature_wrap, " ").concat(moreThanTwo ? _TemperatureBoxModule.default.smaller_margin : '')
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: moreThanTwo ? _TemperatureBoxModule.default.smaller_font : ''
  }, isCorrectTemperature ? temperature === null || temperature === void 0 ? void 0 : temperature.toFixed(1) : '- -'), /*#__PURE__*/_react.default.createElement("span", {
    className: moreThanTwo ? _TemperatureBoxModule.default.smaller_font : ''
  }, tUnit)), /*#__PURE__*/_react.default.createElement("span", {
    className: moreThanTwo ? _TemperatureBoxModule.default.bigger_margin : ''
  }, alone ? tTemperature /* 'Temperature' */ : "".concat(text, " "))), [moreThanTwo, alone, tUnit, temperature, tTemperature]);
};
exports.TemperatureBox = TemperatureBox;